export default __webpack_public_path__ + "e15037fdec566fa8abad47fca874523b.png";